<template>
    <rkm-area
        no-margin-top
        title="Exames realizados"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.objetivo.examesAvaliados"
                    hide-filters
                    hide-pagination
                >
                    <template v-slot="{item}">

                        <rkm-row>
                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => `${formatProcedimento(item.codigoProcedimento)} - ${item.descricao}`"
                                    label="Exame"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.solicitadoEm"
                                    label="Data da solicitação"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.realizadoEm"
                                    label="Data da realização"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.resultadoEm"
                                    label="Data do resultado"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:collapse="{item}">
                        <rkm-row class="p-2">
                            <rkm-col>
                                <Item :get-value="() => item.resultado" />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Item},
    mixins: [formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>